module.exports = __webpack_public_path__ + "static/menu_listen-30e978935f8f5f05b83a5d4b941a64b2.png";